import { asyncRoute } from '../../router';

export default asyncRoute(() => import(/* webpackChunkName: "GameContainer" */ './container/GameContainer'));
